import styled from '@emotion/styled';
import { ExternalLink, InternalNavLink } from '../../../components/Link/Link';
import SwitchAccountButton from '../../../components/Button/SwitchAccountButton';
import {
  healthSignUpInitialValues,
  HealthSignUpDataType,
  HealthSignUpSchema,
  healthSignUpData,
} from '../../../models/auth/healthSignup/healthSignup.model';
import Formtainer from '../../../components/Authlayout/Formtainer';
import useHealthSignup from '../../../hooks/auth/useHealthSignup';
import { FormComponent } from '../../../components/Form/FormComponent';
import {
  PasswordInputField,
  SelectField,
  TextInputField,
  Checkbox,
} from '../../../components/Form/FormField';
import { configSetting } from '../../../config';
import { serviceCat, stateList } from './HealthFormData';
import ValidatingFormSubmitButton from '../../../components/Button/FormSubmitButton';
import { ACCOUNT, HEALTH_SIGNIN } from '../../../routes/routeConstants';
import { FormikHelpers } from 'formik';

const HealthSignUp = () => {
  const { loading, signUpHealth } = useHealthSignup();
  const healthSignUpSubmit = async (
    values: HealthSignUpDataType,
    actions: FormikHelpers<healthSignUpData>
  ) => {
    console.log('Health signup submit value: ', values);
    signUpHealth(values);
    actions.resetForm({ values: healthSignUpInitialValues });
  };

  return (
    <>
      <Formtainer header="CREATE YOUR ACCOUNT">
        <Buttons>
          <SwitchAccountButton
            path={`${configSetting.userDashboardUrl}/account/signup`}
          />
        </Buttons>
        <FormComponent
          initialValues={healthSignUpInitialValues}
          schema={HealthSignUpSchema}
          onSubmit={healthSignUpSubmit}
        >
          <TextInputField
            label="Institution Name"
            name="institutionName"
            type="text"
            placeholder="Enter your institution name"
          />
          <TextInputField
            label="First Name"
            name="firstName"
            type="text"
            placeholder="Enter your first name"
          />
          <TextInputField
            label="Last Name"
            name="lastName"
            type="text"
            placeholder="Enter your last name"
          />
          <TextInputField
            label="Email Address"
            name="email"
            type="email"
            placeholder="Enter your email address"
          />
          <PasswordInputField
            label="Password"
            name="password"
            type="password"
            placeholder="Enter your password"
          />
          <FieldGroups>
            {' '}
            <SelectField
              label="State"
              name="state"
              rpiSrc="/static/img/arrow-down2.png"
            >
              <option value="" disabled>
                Select State
              </option>
              {stateList.map((stateName, index) => (
                <option key={index} value={stateName}>
                  {stateName}
                </option>
              ))}
            </SelectField>
            <TextInputField
              label="City"
              name="city"
              type="text"
              placeholder="Enter City"
            />
          </FieldGroups>
          <TextInputField
            label="Street Address"
            name="street"
            type="text"
            placeholder="Enter your street address"
            rpiSrc="/static/img/Location.png"
          />
          <TextInputField
            label="Local Government"
            name="localGovernment"
            type="text"
            placeholder="Enter L.G.A"
          />
          <SelectField
            label="Service Industry"
            name="serviceIndustry"
            rpiSrc="/static/img/arrow-down2.png"
          >
            <option value="" disabled>
              Select Service Industry
            </option>
            {serviceCat.map((service, index) => (
              <option key={index} value={service}>
                {service}
              </option>
            ))}
          </SelectField>
          <Checkbox name="isTermsAccepted" className="terms">
            <span>
              By creating an account, I agree to the
              <ExternalLink href={`https://locumspace.co/T&Cs`}>
                {' '}
                Terms and Conditions
              </ExternalLink>
            </span>
          </Checkbox>
          <ValidatingFormSubmitButton className="fillParent" loading={loading}>
            Create Account
          </ValidatingFormSubmitButton>
        </FormComponent>
      </Formtainer>
      <P>
        Already have an account?{' '}
        <InternalNavLink
          to={`/${ACCOUNT}/${HEALTH_SIGNIN}`}
          className="regular"
        >
          Sign In
        </InternalNavLink>
      </P>
    </>
  );
};

export default HealthSignUp;

const Buttons = styled.div`
  // border: 1px solid red;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 480px) {
  }
`;

const FieldGroups = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2rem;
`;

const P = styled.div`
  display: flex;
  gap: 4px;
  justify-content: center;
  font-size: 18px;
  color: ${({ theme }) => theme.palette.blackBlack2};
  font-weight: 400;

  @media (max-width: 480px) {
    font-size: 16px;
  }
`;
